// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import { resolveColor } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { siteWidthStyles } from "@toolkit/Themes/common/mixins";
import React from "react";
import { css, useTheme } from "styled-components";

const enum fields {
    title = "title",
    hasContainerPadding = "hasContainerPadding",
    hasCenteredText = "hasCenteredText",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.title]: string;
        [fields.hasContainerPadding]: boolean;
        [fields.hasCenteredText]: boolean;
    };
}

export interface RedBorderedTitleStyles {
    wrapper?: InjectableCss;
    textContainer?: InjectableCss;
    text?: TypographyPresentationProps;
}

const redBorderedTitleStyles: RedBorderedTitleStyles = {
    wrapper: {
        css: css`
            width: 100%;
            border-bottom: ${pxToRem(2)} solid ${getColor("primary")};
        `,
    },
    text: {
        variant: "h6",
        transform: "uppercase",
        css: css`
            padding: ${pxToRem(15)} 0;
        `,
    },
};

const styles = redBorderedTitleStyles;

const RedBorderedTitle = ({ fields: { title, hasContainerPadding, hasCenteredText } }: OwnProps) => {
    const theme = useTheme();
    const wrapperStyles = {
        css: css`
            ${styles.wrapper?.css}
            ${title && `border-top: ${pxToRem(2)} solid ${resolveColor("primary.main", theme)};`}
            ${title && hasCenteredText && `text-align: center;`}
        `,
    };
    const textContainerStyles = {
        css: css`
            ${styles.textContainer?.css}
            ${hasContainerPadding && siteWidthStyles()}
        `,
    };

    return (
        <StyledWrapper {...wrapperStyles}>
            {title && (
                <StyledWrapper {...textContainerStyles}>
                    <Typography {...styles.text}>{title}</Typography>
                </StyledWrapper>
            )}
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: RedBorderedTitle,
    definition: {
        group: "Basic",
        displayName: "Red Border w Title",
        icon: "underline",
        fieldDefinitions: [
            {
                name: fields.title,
                editorTemplate: "TextField",
                fieldType: "Translatable",
                defaultValue: "",
            },
            {
                name: fields.hasContainerPadding,
                displayName: "Add padding on container",
                editorTemplate: "CheckboxField",
                fieldType: "General",
                defaultValue: true,
                variant: "toggle",
                isVisible: widget => widget.fields.title !== "",
            },
            {
                name: fields.hasCenteredText,
                displayName: "Center Text",
                editorTemplate: "CheckboxField",
                fieldType: "General",
                defaultValue: false,
                variant: "toggle",
                isVisible: widget => widget.fields.title !== "",
            },
        ],
    },
};

export default widgetModule;
